import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  untracked,
  ChangeDetectionStrategy
} from "@angular/core";
import { Router } from "@angular/router";
import { formatNumber, NgClass } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SessionDataService } from "../../../../services/shared/SessionDataService.service";
import { HomeService } from "../../home/home.service";
import { RedirectToService } from "../../../../services/shared/RedirectToService.service";
import { GlobalEntityData } from "../../home/HomeInterface.type";
import { GraphControllerComponent } from "../../../../modules/graph-module/graph-controller/graph-controller.component";

/**
 * Shows entity device totals in a row and opens its virtual agrupation, including new-tab navigation.
 * Inputs: `entity` and `height`; emits `showEntity` when the visibility toggle changes.
 */
@Component({
  selector: "app-home-entity-data-row",
  imports: [TranslateModule, GraphControllerComponent, NgClass, FormsModule],
  templateUrl: "./home-entity-data-row.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./home-entity-data-row.component.scss"
})
export class HomeEntityDataRowComponent implements OnInit {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/

  @Input() entity: GlobalEntityData;
  @Output() showEntity = new EventEmitter<any>();
  @Input() height: number;
  numberFormat = untracked(() => this.SessionDataService.numberFormat());

  // Chart
  deviceTotalsHighchartsOptions: any;
  formatNumber = formatNumber;

  /***************************************************************************/
  // ANCHOR Constructor
  /***************************************************************************/

  constructor(
    public HomeService: HomeService,
    private readonly router: Router,
    public SessionDataService: SessionDataService,
    private RedirectToService: RedirectToService
  ) {}

  /***************************************************************************/
  // ANCHOR Component initialization
  /***************************************************************************/

  ngOnInit(): void {
    this.setDeviceTotalsHighchartsOptions();
  }

  /***************************************************************************/
  // ANCHOR Functions
  /***************************************************************************/

  setDeviceTotalsHighchartsOptions(): void {
    let highchartsOptions = {
      exporting: { enabled: false },
      tooltip: { enabled: false },
      credits: { enabled: false },
      accessibility: { enabled: false },
      title: { text: "" },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: false
          }
        },
        bar: {
          stacking: "percent",
          borderWidth: 0.5,
          borderColor: "black",
          animation: false,
          pointWidth: 20,
          dataLabels: { enabled: false }
        }
      }
    };
    this.deviceTotalsHighchartsOptions = highchartsOptions;
  }

  // Select the entity's virtual agrupation before navigating.
  updateNavigation(entity: GlobalEntityData): void {
    this.SessionDataService.sendAgrupation(entity.virtual);
  }

  // Open the entity's virtual agrupation in this tab or a new tab.
  goToEntity(e: MouseEvent, entity: GlobalEntityData, newTab?: boolean): void {
    e.preventDefault();
    if (newTab) {
      this.RedirectToService.setNewTabContext({
        client: untracked(() => this.SessionDataService.client()),
        entity: entity,
        agrupation: entity.virtual
      });
      this.SessionDataService.sendNewTab(newTab);
    } else {
      this.updateNavigation(entity);
    }
    setTimeout(() => {
      this.router.navigate(["principal-agrupacion"]);
    }, 0);
  }
}
